import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m14,11v8s-9,0-9,0v-8h9Zm10,0v8c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5v-8c0-2.757,2.243-5,5-5h4.865L6.232,1.64c-.354-.424-.296-1.055.128-1.408.424-.354,1.054-.296,1.408.128l4.232,5.078L16.232.36c.354-.424.984-.481,1.408-.128s.481.984.128,1.408l-3.633,4.36h4.865c2.757,0,5,2.243,5,5Zm-8,0c0-1.103-.897-2-2-2H5c-1.103,0-2,.897-2,2v8c0,1.103.897,2,2,2h9c1.103,0,2-.897,2-2v-8Zm5.5,6.5c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5,1.5.672,1.5,1.5,1.5,1.5-.672,1.5-1.5Zm0-5c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5,1.5.672,1.5,1.5,1.5,1.5-.672,1.5-1.5Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/tv-icon.jsx